export default class Constants {
    public static dummyPhoneNumber = '6043477336';

    public static smallBagSize = 'small';
    public static largeBagSize = 'large';

    public static smallBagSizeValue = 3.5;
    public static largeBagSizeValue = 10;

    public static snacksSizeValue = 0.5;
    public static smallMealSizeValue = 0.83;
    public static regularMealSizeValue = 1;

    public static regularMealSize = 'medium';

    public static startOfHomeDeliveryTime = '17:00';
    public static startOfOfficeDeliveryTime = '9:00';

    public static endOfHomeDeliveryTime = '22:00';
    public static endOfOfficeDeliveryTime = '17:00';

    public static office = 'office';
    public static home = 'home';
}
